/* Frenchie Shop brand interactions */
(function(){
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* reveal on scroll */
  function reveal(){
    var els=document.querySelectorAll('.dx-rv:not(.is-in)');
    if(!('IntersectionObserver' in window)||reduce){els.forEach(function(e){e.classList.add('is-in')});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target);}})},{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){io.observe(e)});
  }
  /* 3D stage follows pointer */
  function stage(){
    if(reduce)return;
    document.querySelectorAll('[data-dx-stage]').forEach(function(st){
      var inner=st.querySelector('.dx-stage__inner');if(!inner||st.__dx)return;st.__dx=1;
      st.addEventListener('pointermove',function(e){var r=st.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;inner.style.transform='rotateY('+(x*14)+'deg) rotateX('+(-y*10)+'deg)';});
      st.addEventListener('pointerleave',function(){inner.style.transform='';});
    });
  }
  /* delivery estimate: handling 0-3 days + transit 3-14 days (shipping policy) */
  function eta(){
    document.querySelectorAll('[data-dx-eta]').forEach(function(el){
      var a=+el.getAttribute('data-min')||3,b=+el.getAttribute('data-max')||17,d=new Date();
      function f(n){var x=new Date(d.getTime()+n*864e5);return x.toLocaleDateString(undefined,{month:'short',day:'numeric'});}
      var out=el.querySelector('[data-dx-eta-out]');if(out)out.textContent=f(a)+' – '+f(b);
    });
  }
  /* sticky add to cart */
  function satc(){
    var bar=document.querySelector('[data-dx-satc]');if(!bar||bar.__dx)return;bar.__dx=1;
    var btn=document.querySelector('product-form [name="add"]');if(!btn){bar.remove();return;}
    var price=bar.querySelector('[data-dx-satc-price]'),label=bar.querySelector('[data-dx-satc-label]');
    function sync(){var p=document.querySelector('.product__info-container .price .price-item--sale, .product__info-container .price .price-item--regular');if(p&&price)price.textContent=p.textContent.trim();if(label){label.textContent=btn.disabled?(btn.textContent.trim()||'Sold out'):bar.getAttribute('data-label');}bar.querySelector('button').disabled=btn.disabled;}
    new IntersectionObserver(function(en){var e=en[0];bar.classList.toggle('is-on',!e.isIntersecting&&e.boundingClientRect.top<0);sync();}).observe(btn);
    bar.querySelector('button').addEventListener('click',function(){
      var picker=document.querySelector('variant-selects, variant-radios');
      if(btn.disabled){(picker||btn).scrollIntoView({behavior:'smooth',block:'center'});return;}
      btn.click();
    });
    document.addEventListener('change',function(e){if(e.target.closest('variant-selects, variant-radios'))setTimeout(sync,400);});
  }
  /* cart trust row under checkout buttons (drawer + cart page) */
  function cartTrust(){
    var tpl=document.getElementById('dx-ct-tpl');if(!tpl)return;
    document.querySelectorAll('.cart__ctas').forEach(function(ctas){
      var host=ctas.parentNode;if(!host||host.querySelector('.dx-ct'))return;
      var dyn=host.querySelector('.cart__dynamic-checkout-buttons');
      (dyn||ctas).insertAdjacentElement('afterend',tpl.content.firstElementChild.cloneNode(true));
    });
  }
  function watchCart(){
    cartTrust();
    ['cart-drawer','#main-cart-footer','cart-drawer-items','.cart__footer-wrapper'].forEach(function(sel){
      var el=document.querySelector(sel);if(el&&!el.__dxo){el.__dxo=1;new MutationObserver(cartTrust).observe(el,{childList:true,subtree:true});}
    });
  }
  /* size chart popup from description images/tables */
  function sizeChart(){
    document.querySelectorAll('[data-dx-sc]').forEach(function(box){
      if(box.__dx)return;box.__dx=1;
      var src=box.querySelector('[data-dx-sc-src]'),body=box.querySelector('[data-dx-sc-body]');if(!src||!body)return;
      var frag=src.content,found=0,re=/size|chart|measur|guide/i;
      /* group images that sit together (no real text between them); show a group if it follows
         size-related text or if any image in it looks like a size chart */
      var txtRe=/size chart|size guide|sizing|size selection|how to measure|measurements?\b|choose the (right|correct) size/i,started=false,groups=[],g=null;
      var walker=document.createTreeWalker(frag,NodeFilter.SHOW_ELEMENT|NodeFilter.SHOW_TEXT),n;
      while((n=walker.nextNode())){
        if(n.nodeType===3){var t=n.textContent.trim();if(txtRe.test(t))started=true;if(t.length>=20)g=null;continue;}
        if(n.tagName!=='IMG')continue;
        if(!g){g={imgs:[],hit:started};groups.push(g);}
        g.imgs.push(n);
        if(re.test((n.getAttribute('src')||'')+' '+(n.getAttribute('alt')||'')))g.hit=true;
      }
      groups.forEach(function(gr){if(!gr.hit)return;gr.imgs.forEach(function(im){var c=im.cloneNode(true);c.removeAttribute('style');c.removeAttribute('width');c.removeAttribute('height');c.loading='lazy';body.appendChild(c);found++;});});
      frag.querySelectorAll('table').forEach(function(t){if(re.test(t.textContent)||/\b(xs|s|m|l|xl)\b/i.test(t.textContent)){var w=document.createElement('div');w.className='dx-sc__tbl';w.appendChild(t.cloneNode(true));body.appendChild(w);found++;}});
      if(!found)return;
      box.hidden=false;
      var dlg=box.querySelector('dialog');
      box.querySelector('[data-dx-sc-open]').addEventListener('click',function(){if(dlg.showModal)dlg.showModal();else dlg.setAttribute('open','');});
      box.querySelector('[data-dx-sc-close]').addEventListener('click',function(){dlg.close();});
      dlg.addEventListener('click',function(e){if(e.target===dlg)dlg.close();});
    });
  }
  /* frequently bought together */
  function fbt(){
    document.querySelectorAll('[data-dx-fbt]').forEach(function(box){
      if(box.__dx)return;box.__dx=1;
      var main;try{main=JSON.parse(box.querySelector('[data-dx-fbt-main]').textContent);}catch(e){return;}
      var picks=[];try{picks=JSON.parse(box.querySelector('[data-dx-fbt-picks]').textContent)||[];}catch(e){}
      var L={};try{L=JSON.parse((box.querySelector('[data-dx-fbt-i18n]')||{}).textContent||'{}');}catch(x){}function t(k,d){return L[k]||d;}
      var limit=+box.getAttribute('data-limit')||2,root=box.getAttribute('data-root')||'/',cur=box.getAttribute('data-currency')||'USD';
      function money(c){try{return new Intl.NumberFormat(document.documentElement.lang||undefined,{style:'currency',currency:cur}).format(c/100);}catch(e){return (c/100).toFixed(2);}}
      function esc(t){var d=document.createElement('div');d.textContent=t==null?'':t;return d.innerHTML;}
      function fromRec(p){return {id:p.id,title:p.title,url:p.url,image:(p.featured_image||'').replace(/^\/\//,'https://'),available:p.available,variants:(p.variants||[]).map(function(v){return {id:v.id,title:v.title,price:v.price,compare_at_price:v.compare_at_price||0,available:v.available};})};}
      function purpose(){
        var title=(main.title||'').toLowerCase(),cs=(main.collections||[]).join(' ');
        var human=(main.collections||[]).some(function(c){return /^(hoodies|t-shirt|bath-robe|bath-towel-for-frenchies-lovers|bathroom-toilet-set-for-frenchies-lovers|bedding-set|cushions|french-bulldog-shower-curtains|car-seat-covers|car-pet-seat-cover-for-frenchies-lovers|french-bulldog-pajamas-for-human|french-bulldog-pajamas-for-women|french-bulldog-puzzles|fashion-boots)$/.test(c);});
        if(human)return [];
        var a=[];
        if(/raincoat|rain coat|poncho|waterproof.*jacket/.test(title))a.push('rain','walk');
        else if(/winter|warm.*(jacket|coat|boot)|snow|fleece.*(jacket|coat)/.test(title))a.push('cold','walk');
        if(/harness|leash|collar/.test(title)||/french-bulldog-harness|frenchie-dog-collar/.test(cs))a.push('walk');
        if(/\b(bowl|feeder|feeding mat)\b/.test(title))a.push('meal');
        if(/\b(bed|cave|sleeping nest|pajamas|sleepwear)\b/.test(title)||/bed-for-frenchies|pajamas-for-french-bulldog/.test(cs))a.push('rest');
        if(/\b(toy|tugtoy|snuffle|puzzle feeder)\b/.test(title)||/french-bulldog-toys/.test(cs))a.push('play');
        if(/\b(carrier|backpack|travel|portable|car seat|seat belt|life vest|life jacket)\b/.test(title)||/dog-backpack|french-bulldog-life-jackets/.test(cs))a.unshift('travel');
        if(/bath|groom|shampoo|bath brush|drying|microfiber|quick-dry/.test(title))a.unshift('bath');
        if(!a.length&&/french-bulldog-clothes|french-bulldog-hoodies|french-bulldog-jackets|wool-sweater-for-frenchies|clothes-for-frenchies-girls/.test(cs))a.push('walk');
        return Array.from(new Set(a));
      }
      function candidates(){
        var use=purpose(),title=(main.title||'').toLowerCase();
        if(!use.length)return [];
        var pool=[
          {h:'frenchie-towel',role:'towel',uses:{rain:12,bath:10,travel:7}},
          {h:'boots',role:'boots',uses:{cold:12,rain:8}},
          {h:'frenchie-leash-5-frenchie-essentials-all-in-one',role:'leash',uses:{walk:11}},
          {h:'peticlean-portable-pooper-scooper-with-waste-bag-dispenser-for-frenchie',role:'waste',uses:{walk:10,travel:5}},
          {h:'pawsip-bottle',role:'water',uses:{travel:12,walk:9}},
          {h:'frenchie-toys-10',role:'toy',uses:{rest:10,play:7}},
          {h:'bowl3',role:'bowl',uses:{rest:7}},
          {h:'frenchie-feeding-mat',role:'mat',uses:{meal:12}},
          {h:'donutly',role:'bed',uses:{rest:11,play:8}},
          {h:'snuffle-mat-ws93',role:'enrichment',uses:{meal:8,play:10}},
          {h:'french-bulldog-soft-silicone-bath-brush',role:'brush',uses:{bath:12}},
          {h:'reflective-harness',role:'harness',uses:{walk:8}}
        ];
        var included=[];
        if(/leash/.test(title))included.push('leash');
        if(/harness/.test(title))included.push('harness');
        if(/bottle|\bbowl\b|feeder/.test(title))included.push('water','bowl','enrichment');
        if(/feeding mat|snuffle|lick mat/.test(title))included.push('mat','enrichment');
        if(/\bbed\b|cave|sleeping nest/.test(title))included.push('bed');
        if(/\btoy\b|tugtoy/.test(title))included.push('toy','enrichment');
        if(/\bboots?\b|shoes|socks/.test(title))included.push('boots');
        if(/towel|bathrobe/.test(title))included.push('towel');
        if(/brush|glove/.test(title))included.push('brush');
        if(/poop|waste bag/.test(title))included.push('waste');
        return pool.filter(function(p){return p.h!==main.handle&&!included.includes(p.role);}).map(function(p){
          p.score=Math.max.apply(null,use.map(function(u,i){return (p.uses[u]||0)*(i===0?1:0.65);}));return p;
        }).filter(function(p){return p.score>0;}).sort(function(a,b){return b.score-a.score;});
      }
      function usable(p){return p&&+p.id!==+main.id&&p.available&&p.variants&&p.variants.some(function(v){return v.available;});}
      function curated(){
        var pool=candidates();
        function batch(at,chosen){
          if(chosen.length>=limit||at>=pool.length)return Promise.resolve(chosen.slice(0,limit));
          return Promise.all(pool.slice(at,at+limit).map(function(p){
            return fetch(root.replace(/\/$/,'')+'/products/'+encodeURIComponent(p.h)+'.js')
              .then(function(r){return r.ok?r.json():null;}).then(function(p){return usable(p)?fromRec(p):null;}).catch(function(){return null;});
          })).then(function(a){return batch(at+limit,chosen.concat(a.filter(Boolean)));});
        }
        return batch(0,[]);
      }
      function load(){
        if(picks.some(usable))return Promise.resolve(picks.filter(usable));
        if(candidates().length)return curated();
        var base=root.replace(/\/$/,'')+'/recommendations/products.json?product_id='+main.id+'&limit='+(limit+4);
        return fetch(base+'&intent=complementary').then(function(r){return r.ok?r.json():{products:[]};})
          .then(function(j){return (j.products||[]).filter(usable).map(fromRec);}).catch(function(){return [];});
      }
      load().then(function(list){
        list=list.filter(function(p,i,a){return usable(p)&&a.findIndex(function(x){return +x.id===+p.id;})===i;}).slice(0,limit);
        if(!list.length)return;
        var items=[{p:main,main:true}].concat(list.map(function(p){return {p:p};}));
        var imgs=box.querySelector('[data-dx-fbt-imgs]'),ul=box.querySelector('[data-dx-fbt-list]');
        items.forEach(function(it,i){
          if(i)imgs.insertAdjacentHTML('beforeend','<span class="dx-fbt__plus">+</span>');
          imgs.insertAdjacentHTML('beforeend','<a href="'+esc(it.p.url)+'" data-i="'+i+'">'+(it.p.image?'<img src="'+esc(it.p.image)+'" alt="'+esc(it.p.title)+'" loading="lazy">':'')+'</a>');
          var av=it.p.variants.filter(function(v){return v.available;});
          var sel=(!it.main&&av.length>1)?'<select data-i="'+i+'" aria-label="'+esc(t('option_for','Option for'))+' '+esc(it.p.title)+'">'+av.map(function(v){return '<option value="'+v.id+'">'+esc(v.title)+'</option>';}).join('')+'</select>':'';
          it.variant=it.main?null:av[0];
          ul.insertAdjacentHTML('beforeend','<li class="dx-fbt__item"><input type="checkbox" checked data-i="'+i+'" aria-label="'+esc(t('include','Include'))+' '+esc(it.p.title)+'"'+(it.main?' disabled':'')+'><div>'+(it.main?'<b>'+esc(t('this_item','This item:'))+'</b> ':'')+'<a href="'+esc(it.p.url)+'">'+esc(it.p.title)+'</a>'+(it.main?'<small data-dx-fbt-mainv></small>':'')+sel+'</div><div class="dx-fbt__price" data-price="'+i+'"></div></li>');
          it.on=true;
        });
        function mainVariant(){
          var input=document.querySelector('product-form form input[name="id"], form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
          var id=input?+input.value:0;
          return main.variants.filter(function(v){return v.id===id;})[0]||main.variants.filter(function(v){return v.available;})[0]||main.variants[0];
        }
        function render(){
          var tot=0,cmp=0,n=0;items[0].variant=mainVariant();
          var mv=box.querySelector('[data-dx-fbt-mainv]');if(mv)mv.textContent=items[0].variant&&items[0].variant.title!=='Default Title'?items[0].variant.title:'';
          items.forEach(function(it,i){
            var v=it.variant,cell=box.querySelector('[data-price="'+i+'"]');
            cell.innerHTML=v?money(v.price)+(v.compare_at_price>v.price?'<s>'+money(v.compare_at_price)+'</s>':''):'';
            var a=imgs.querySelector('a[data-i="'+i+'"]');if(a)a.classList.toggle('is-off',!it.on);
            if(it.on&&v){tot+=v.price;cmp+=Math.max(v.compare_at_price,v.price);n++;}
          });
          box.querySelector('[data-dx-fbt-total]').textContent=money(tot);
          box.querySelector('[data-dx-fbt-compare]').textContent=cmp>tot?money(cmp):'';
          var b=box.querySelector('[data-dx-fbt-add]');b.textContent=n>1?t('add_all','Add all {n} to cart').replace('{n}',n):t('add','Add to cart');
          b.disabled=!items[0].variant||!items[0].variant.available;
        }
        box.addEventListener('change',function(e){
          var i=+e.target.getAttribute('data-i');if(isNaN(i))return;
          if(e.target.type==='checkbox')items[i].on=e.target.checked;
          if(e.target.tagName==='SELECT')items[i].variant=items[i].p.variants.filter(function(v){return v.id===+e.target.value;})[0];
          render();
        });
        document.addEventListener('change',function(e){if(e.target.closest&&e.target.closest('variant-selects, variant-radios, product-form'))setTimeout(render,300);});
        box.querySelector('[data-dx-fbt-add]').addEventListener('click',function(){
          var btn=this,err=box.querySelector('[data-dx-fbt-err]');err.hidden=true;
          var payload=items.filter(function(it){return it.on&&it.variant;}).map(function(it){return {id:it.variant.id,quantity:1};});
          var drawer=document.querySelector('cart-drawer');
          var body={items:payload};
          if(drawer&&drawer.getSectionsToRender){body.sections=drawer.getSectionsToRender().map(function(s){return s.id;});body.sections_url=location.pathname;}
          btn.disabled=true;var old=btn.textContent;btn.textContent=t('adding','Adding…');
          fetch(root.replace(/\/$/,'')+'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})
            .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;});})
            .then(function(j){
              btn.textContent=old;btn.disabled=false;
              if(drawer&&drawer.renderContents&&j.sections){drawer.classList.remove('is-empty');j.id=payload[0].id;drawer.renderContents(j);}
              else location.href=root.replace(/\/$/,'')+'/cart';
            })
            .catch(function(e){btn.textContent=old;btn.disabled=false;err.textContent=(e&&(e.description||e.message))||t('add_err','Could not add to cart. Please try again.');err.hidden=false;});
        });
        render();box.hidden=false;
      });
    });
  }
  function init(){reveal();stage();eta();satc();watchCart();sizeChart();fbt();}
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();
